import React from "react";
import { TextBox } from "devextreme-react";

const PassworReset = ({ value, onValueChange }) => {
  const { admin_password_reset_notifications_emails } = value;

  return (
    <div className='mb-5'>
      <table className='table table-bordered align-middle mt-1'>
        <thead className='table-dark'>
          <tr>
            <th scope='col'>Setting</th>
            <th scope='col'>Value</th>
            <th scope='col'>Explanation</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope='row'>
              Email Addresses for Password Reset Notifications
            </th>
            <td className='text-center' style={{ width: "40%" }}>
              {" "}
              <TextBox
                width={"100%"}
                value={admin_password_reset_notifications_emails}
                onValueChanged={(e) =>
                  onValueChange(e, "admin_password_reset_notifications_emails")
                }
              />
              <small style={{ marginTop: "5px" }}>
                Use commas to separate email addresses
              </small>
            </td>
            <td style={{ width: "30%" }}>
              A notification will be sent to these email addresses whenever a
              user requests a password reset. <br />
              You can configure multiple addresses, comma-separated. <br />
              Leave the field empty to disable notifications.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default PassworReset;
